import type { ExportNotificationEntry } from '@ikegps/core-api';
import { CollectionModel } from '@ikegps/core-shared';
import { addStyles } from '../../components/theme';
import { T, Translate } from '../../i18n';
import type { MithrilVNode } from '../../mithril';
import { m } from '../../mithril';
import { ExportNotificationCtrl } from './export.notification.ctrl';
import { ExportNotificationDetail } from './export.notification.detail/export.notification.detail';
import { ExportNotificationDetailCtrl } from './export.notification.detail/export.notification.detail.ctrl';
import { CSS, Style } from './export.notification.style';

addStyles(Style);

function viewNotificationDetail(
	notificationEntries: ExportNotificationEntry[],
	collection: CollectionModel
): MithrilVNode[] {
	return notificationEntries.map((notificationEntry) => {
		const detailCtrl = new ExportNotificationDetailCtrl(notificationEntry, collection);
		return ExportNotificationDetail.view(detailCtrl);
	});
}

function viewContent(ctrl: ExportNotificationCtrl): MithrilVNode {
	const children = ctrl.notifications.map((notification) => {
		const revision = notification.revision;
		const collection = ctrl.getCollection(revision);
		const entries = ctrl.errors ? notification.errors : notification.warnings;

		return m('div', { className: CSS.section }, [
			m('span', ctrl.getTitleFieldName(revision) + ': '),
			m('span', { className: CSS.title }, collection.title),
			m('ul', { className: CSS.content }, viewNotificationDetail(entries, collection)),
		]);
	});

	return m('div', { className: CSS.container }, children);
}

function viewTitle(ctrl: ExportNotificationCtrl): string {
	return ctrl.errors ? Translate(T.NOTIFICATION_ERROR_TITLE) : Translate(T.NOTIFICATION_WARNING_TITLE);
}

export const ExportNotificationContent = { view: viewContent };
export const ExportNotificationTitle = { view: viewTitle };
